/*
 * OfferDatailsSelectorConstants
 */

export const DISPLAY_OFFERS = 'ideal/components/OfferDetails/DISPLAY_OFFERS';
export const OFFER_SELECTED = 'ideal/components/OfferDetails/OFFER_SELECTED';


